module.exports = __webpack_public_path__ + "img/icon_building.26233d51.svg";